import React, { useEffect, useState } from 'react';
import Styles from './CarrosEletricosPremioMobilidade.css';
import Container from '../../atoms/Container';
import RedButton from '../../atoms/RedButton/RedButton';
import { isBrowser, isMobile } from '../../../utils/browser';

function CarrosEletricosPremioMobilidade() {
  return (
    <>
      <section id="carros-eletricos-premio-mobilidade">
        <Container>
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/o4_FvyRpcyI?si=ZMcvCjVEAd7ffjC3&amp;controls=0"
            title="Video no Youtube falando sobre o prêmio Santander pela Mobilidade e Inovação Sustentável"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            className="carros-eletricos-premio-mobilidade-img"
          />
          {/* <picture>
            <source type="image/png" srcSet="assets/carros-eletricos/img-mobilidade.png" />
            <img
              className="carros-eletricos-premio-mobilidade-img"
              src="assets/carros-eletricos/img-mobilidade.png"
              alt="financiar veículo"
            />
          </picture> */}
          <div className="carros-eletricos-premio-mobilidade-contain">
            <img
              className="carros-eletricos-premio-mobilidade-logo-desk"
              src="assets/carros-eletricos/premio-logo-desk.png"
              alt="financiar veículo"
            />
            <h3 className="carros-eletricos-premio-mobilidade-titulo">
              Iniciativa para lojas e concessionárias parceiras Santander
            </h3>
            <p className="carros-eletricos-premio-mobilidade-texto">
              O prêmio Santander pela Mobilidade & Inovação Sustentável tem como objetivo reconhecer
              iniciativas que contribuem para o universo ESG.
              <img
                className="carros-eletricos-premio-mobilidade-logo"
                src="assets/carros-eletricos/premio-logo-mobile.png"
                alt="financiar veículo"
              />
            </p>
            <RedButton
              className="btn-premio-saiba-mais"
              href="pdf/guia-de-bolso-premio-santander-mobilidade.pdf"
              target="_blank"
            >
              Saiba mais sobre o prêmio
            </RedButton>

            <a
              href="pdf/edital-de-selecao-premio-santander-pela-mobilidade-inovacao-sustentavel-2023.pdf"
              target="_blank"
              rel="noopener"
              id="regulamento-premio-mobilidade"
              className="premio-regulamento"
            >
              Leia o regulamento
            </a>
          </div>
        </Container>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosPremioMobilidade;
